import Modal from 'components/common/modal';
import Text from 'components/inputs/text';
import Textarea from 'components/inputs/textarea';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

type ReportIssueModalProps = Readonly<{
  openState: [boolean, Dispatch<SetStateAction<boolean>>];
  onConfirm: (subject: string, explanation: string) => void;
}>;

export default function ReportIssueModal({
  openState,
  onConfirm
}: ReportIssueModalProps) {
  const [open] = openState;
  const [subject, setSubject] = useState('');
  const [explanation, setExplanation] = useState('');

  useEffect(() => {
    if (open) {
      setSubject('');
      setExplanation('');
    }
  }, [open]);

  const trimmedSubject = subject.trim();
  const trimmedExplanation = explanation.trim();
  const saveDisabled =
    trimmedSubject.length === 0 || trimmedExplanation.length === 0;

  const handleSave = () => {
    if (saveDisabled) {
      return;
    }
    onConfirm(trimmedSubject, trimmedExplanation);
  };

  return (
    <Modal
      title='Report Issue'
      buttonText='Send Report'
      openState={openState}
      onSave={handleSave}
      saveDisabled={saveDisabled}
      ignoreInErrorLogScreenshot
    >
      <div className='flex flex-col gap-4'>
        <div className='text-sm text-gray-600'>
          Describe what happened. Your current page, a screenshot, recent
          actions, browser console and project state are attached automatically
          so the team can reproduce the issue.
        </div>
        <div className='flex flex-col gap-2'>
          <label
            htmlFor='report-issue-subject'
            className='font-semibold text-gray-900'
          >
            Subject <span className='text-red-600'>*</span>
          </label>
          <Text
            id='report-issue-subject'
            value={subject}
            onChange={setSubject}
            placeholder='Short summary of the problem'
            autoFocus
          />
        </div>
        <div className='flex flex-col gap-2'>
          <label
            htmlFor='report-issue-explanation'
            className='font-semibold text-gray-900'
          >
            Explanation <span className='text-red-600'>*</span>
          </label>
          <Textarea
            id='report-issue-explanation'
            value={explanation}
            onChange={setExplanation}
            placeholder='What were you doing, what did you expect, and what happened instead?'
            rows={6}
          />
        </div>
      </div>
    </Modal>
  );
}
